import {
  ChangeDetectionStrategy,
  Component,
  TemplateRef,
  computed,
  effect,
  inject,
  input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { PageNavigatorService } from '../../services/navigator.service';
import { Router, RouterLink } from '@angular/router';
import { Action } from '../../interfaces/page-navigator-setup.model';
import { popupAnimation } from '@comparit/core';

@Component({
  selector: 'ui-page-navigator',
  imports: [CommonModule, MatIcon, MatButtonModule, RouterLink],
  templateUrl: './navigator.component.html',
  styleUrl: './navigator.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [popupAnimation],
})
export class NavigatorComponent {
  navigatorService = inject(PageNavigatorService);
  router = inject(Router);

  template = input<TemplateRef<unknown>>();

  protected resolvedTemplate = computed(
    () => this.template() ?? this.navigatorService.setup()?.contentTemplate ?? null
  );

  constructor() {
    effect(() => {
      const _ = this.navigatorService.setup();
      this.navigatorService.stepInteracted.set(false);
    });
  }

  prevInvalidSteps = computed(() =>
    this.navigatorService.stepsState().some(invalidState => invalidState === true)
  );

  forward(action?: Action) {
    this.navigatorService.stepInteracted.set(true);

    if (action?.callback) action.callback();
  }

  showError = computed(() => this.navigatorService.stepInteracted() && this.prevInvalidSteps());
}
